import { Grid, makeStyles } from "@material-ui/core";
import React from "react";
import { useParams } from "react-router-dom";
import { Skeleton } from "@material-ui/lab";
import { ItemHeader } from "./ItemHeader";
import { Form } from "./Form";
import { NonNullableItemState } from "../../redux/state";
import { ModuleAppBar } from "../ModuleAppBar";
import { useItemState } from "../../hooks/useItemState";
import { CaoScrollableAreaTabs } from "./CaoScrollableAreaTabs";
import { useRecipientsState } from "../../hooks/useRecipientsState";
import { useAuth } from "@ofqual/portal-core/core/hooks/useAuth";
import { UserType } from "../../redux/types";
import { MODULE_NAME } from "../../moduleName";
import { authSelector } from "../../redux/selectors";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up("lg")]: {
      marginTop: theme.contentOffsets.AFTER_RECORD_HEADER,
    },
    [theme.breakpoints.down("md")]: {
      marginTop: "25px",
    },
  },
}));

export const Item: React.FC = () => {
  const classes = useStyles();

  const { id, itemId } = useParams<{
    id: string;
    itemId: string;
  }>();

  const state = useItemState(id);
  const recipientsState = useRecipientsState(id, itemId);
  const recipientOrg =
    recipientsState?.viewModel.orgs.find(
      // we should only have our own organisation in the recipientsState, so
      //   recipientsState?.viewModel.orgs[0] could also do the job
      (org) => org.id.toString() === itemId
    ) || null;

  const { userType } = useAuth(authSelector);
  return (
    <div className={classes.root}>
      <ModuleAppBar
        breadcrumbs={[
          {
            label: state?.item?.subject ? state.item.subject : "New",
            to: userType === UserType.Ofqual ? `${id}` : undefined,
            dataTest: "breadcrumb-parent",
          },
          {
            label: recipientOrg?.name || recipientOrg?.id || "",
          },
        ]}
      ></ModuleAppBar>

      <ItemHeader state={state} recipientOrg={recipientOrg} />

      <Grid container spacing={3}>
        <Grid item md={12} lg={6}>
          {state && recipientOrg && recipientsState ? (
            <Form
              state={state as NonNullableItemState}
              recipientOrg={recipientOrg}
              roles={recipientsState.viewModel.roles}
            />
          ) : (
            <>
              <Skeleton variant="text" height={60} />
              <Skeleton variant="text" height={60} />
              <Skeleton variant="text" height={60} />
              <br />
              <Skeleton variant="rect" height={118} />
            </>
          )}
        </Grid>

        <Grid item md={12} lg={6}>
          <CaoScrollableAreaTabs
            itemState={state}
            informationRequestId={id}
            recipientOrg={recipientOrg}
            itemId={itemId}
          />
        </Grid>
      </Grid>
    </div>
  );
};
